import { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../../services/config/api';
import '../../styles/portal-auth.scss';

function RiskPortalForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async () => {
        if (!email) { setError('Please enter your work email.'); return; }
        setLoading(true); setError('');
        try {
            const axios = (await import('axios')).default;
            await axios.post(
                API.RISK_PORTAL_FORGOT_PASSWORD,
                { email },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2',
                    },
                }
            );
            setSuccess(true);
        } catch (e) {
            const msg = e?.response?.data?.response_data?.message || e?.response?.data?.error?.message || '';
            setError(msg || 'Something went wrong. Please try again.');
        }
        setLoading(false);
    };

    const features = [
        'End-to-end risk lifecycle management',
        'Severity-tiered risk acceptance workflow',
        'KRI tracking & treatment monitoring',
        'Role-based collaboration & sign-offs',
    ];

    return (
        <div className="portal-auth-wrapper">
            {/* Left branding panel */}
            <div className="portal-left-panel">
                <div className="portal-left-content">
                    <p className="portal-title-main">Risk</p>
                    <p className="portal-title-accent">Portal</p>
                    <p className="portal-tagline">
                        Centralised risk management, treatment tracking, and real-time reporting — all in one place.
                    </p>
                    <div className="portal-features">
                        {features.map((text, i) => (
                            <div key={i} className="portal-feature-item">
                                <span className="portal-check">✓</span>
                                <span>{text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Right form panel */}
            <div className="portal-form-panel">
                <div className="portal-form-wrapper">
                    <div className="portal-logo-wrap">
                        <img src="/assets/small_logo.svg" alt="NMT" width={300} height={90} onError={e => { e.target.style.display = 'none'; }} />
                    </div>

                    <div className="portal-card">
                        <h1 className="portal-card-title">Forgot Password</h1>
                        <p className="portal-card-subtitle">
                            Enter your work email and we'll send you a link to reset your password.
                        </p>

                        {error && <div className="portal-alert portal-alert--error">{error}</div>}

                        {success ? (
                            <>
                                <div className="portal-alert portal-alert--success">
                                    ✓ &nbsp;A password reset link has been sent to <strong>{email}</strong>. Please check your inbox.
                                </div>
                                <Link to="/risk-portal/login" className="portal-back-link">← Back to Login</Link>
                            </>
                        ) : (
                            <>
                                <div className="portal-form-group">
                                    <label htmlFor="rp-email">Work Email</label>
                                    <input
                                        id="rp-email"
                                        type="email"
                                        className="portal-input"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                                        placeholder="user@company.com"
                                        autoFocus
                                    />
                                </div>

                                <button className="portal-submit-btn" onClick={handleSubmit} disabled={loading}>
                                    {loading ? 'Sending...' : 'Send Reset Link'}
                                </button>

                                <Link to="/risk-portal/login" className="portal-back-link">← Back to Login</Link>
                            </>
                        )}

                        <div className="portal-card-footer">
                            Foresee Security &nbsp;·&nbsp; Risk Portal
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RiskPortalForgotPassword;
